import React from "react";

import { useBroadcastEditContext } from "./BroadcastEditContainer";
import SendTestOverlay from "../BeefreeTemplates/SendTestOverlay";
import RecipientsTab from "./RecipientsTab";
import FromTab from "./FromTab";
import ContentSelectTab from "./ContentSelectTab";
import ReviewAndScheduleTab from "./ReviewAndScheduleTab";
import EmailPreviewTab from "./EmailPreviewTab";
import EmailContentTab from "./EmailContentTab";
import DetailsTab from "./DetailsTab";
import OverviewTab from "./OverviewTab";
import EmailSentTab from "./EmailSentTab";
import BroadcastEditHeader from "./BroadcastEditHeader";
import ScheduledSendPane from "./ScheduledSendPane";
import TwilioEditorTab from "./TwilioEditorTab";
import TwilioContentTab from "./TwilioContentTab";

const BroadcastEdit = () => {
  const {
    tab,
    previouslySent,
    isEmailTemplate,
  } = useBroadcastEditContext();

  return (
    <div>
      <SendTestOverlay templatableContext={useBroadcastEditContext} />
      <ScheduledSendPane />
      <BroadcastEditHeader />
      {tab === "overview" && previouslySent && isEmailTemplate ? (
        <OverviewTab />
      ) : tab === "recipients" ? (
        <RecipientsTab />
      ) : tab === "from" ? (
        <FromTab />
      ) : tab === "content-select" ? (
        <ContentSelectTab />
      ) : tab === "review-and-schedule" ? (
        <ReviewAndScheduleTab />
      ) : tab === "content" ? (
        <EmailContentTab />
      ) : tab === "preview" ? (
        <EmailPreviewTab />
      ) : tab === "twilio-editor" ? (
        <TwilioEditorTab />
      ) : tab === "twilio-content" ? (
        <TwilioContentTab />
      ) : tab === "details" ? (
        <DetailsTab />
      ) : (
        <EmailSentTab />
      )}
    </div>
  );
};

export default BroadcastEdit;
